"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/legacy_portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalAccountService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.account.v1.LegacyPortalAccountService
 */
exports.LegacyPortalAccountService = {
    typeName: "spwn.account.v1.LegacyPortalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.SignInWithFanyId
         */
        signInWithFanyId: {
            name: "SignInWithFanyId",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceSignInWithFanyIdRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceSignInWithFanyIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.LinkWithFanyId
         */
        linkWithFanyId: {
            name: "LinkWithFanyId",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceLinkWithFanyIdRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceLinkWithFanyIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.IssueOidcLoginCode
         */
        issueOidcLoginCode: {
            name: "IssueOidcLoginCode",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceIssueOidcLoginCodeRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceIssueOidcLoginCodeResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map